import { PromptVersion } from "@/types";
import { PlaygroundSession } from "../Playground2";
import PlaygroundShimmer from "../Playground2/PlaygroundShimmer";

const EditorContent = ({
  isLoading,
  promptVersion,
  instanceId,
}: {
  isLoading: boolean;
  promptVersion?: PromptVersion;
  instanceId: string;
}) => {
  return (
    <div className="h-full">
      {!isLoading && promptVersion ? (
        <PlaygroundSession
          editor
          instanceId={instanceId}
          selectedTemplateVersion={promptVersion}
          blueprint={{
            prompt_template: promptVersion.prompt_template,
            provider_base_url_name: promptVersion.provider_base_url_name,
            commit_message: promptVersion.commit_message ?? undefined,
            metadata: promptVersion.metadata,
            report_id: promptVersion.report_id ?? undefined,
          }}
        />
      ) : (
        <PlaygroundShimmer />
      )}
    </div>
  );
};

export default EditorContent;
